export default __webpack_public_path__ + "static/media/174.b7aa12aa.jpg";